var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g2, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConstructionManual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 192,
    height: 169,
    viewBox: "0 0 192 169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3040",
    "data-name": "Rectangle 3040",
    width: 192,
    height: 169,
    transform: "translate(5845 14471.143)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3034",
    "data-name": "Rectangle 3034",
    width: 154.506,
    height: 151.614,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3036",
    "data-name": "Rectangle 3036",
    width: 21.114,
    height: 39.97,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_12",
    "data-name": "Mask Group 12",
    transform: "translate(-5845 -14471.143)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3526",
    "data-name": "Group 3526",
    transform: "translate(5859.043 14480.598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3515",
    "data-name": "Group 3515",
    transform: "translate(4.036 4.217)",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3516",
    "data-name": "Group 3516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3515-2",
    "data-name": "Group 3515",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4874",
    "data-name": "Path 4874",
    d: "M231.089,68.391h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -60.415)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4875",
    "data-name": "Path 4875",
    d: "M231.089,74.264h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -64.298)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4876",
    "data-name": "Path 4876",
    d: "M231.089,116.32h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -92.104)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4877",
    "data-name": "Path 4877",
    d: "M231.089,122.194h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -95.987)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4878",
    "data-name": "Path 4878",
    d: "M231.089,164.25h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -123.793)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4879",
    "data-name": "Path 4879",
    d: "M231.089,170.123h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -127.676)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4880",
    "data-name": "Path 4880",
    d: "M231.089,212.179h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -155.481)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4881",
    "data-name": "Path 4881",
    d: "M231.089,218.052h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -159.364)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4882",
    "data-name": "Path 4882",
    d: "M231.089,260.108h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -187.17)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4883",
    "data-name": "Path 4883",
    d: "M231.089,265.981h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -191.053)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4884",
    "data-name": "Path 4884",
    d: "M231.089,308.037h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -218.859)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4885",
    "data-name": "Path 4885",
    d: "M231.089,313.91h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -222.741)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4886",
    "data-name": "Path 4886",
    d: "M231.089,355.966h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -250.547)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4887",
    "data-name": "Path 4887",
    d: "M231.089,361.839h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -254.43)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4888",
    "data-name": "Path 4888",
    d: "M231.089,403.9h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -282.236)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4889",
    "data-name": "Path 4889",
    d: "M231.089,409.768h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -286.118)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4890",
    "data-name": "Path 4890",
    d: "M231.089,451.824h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -313.924)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4891",
    "data-name": "Path 4891",
    d: "M231.089,457.7h-4.415a.552.552,0,0,1-.551-.551V457a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-192.958 -317.807)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4892",
    "data-name": "Path 4892",
    d: "M350.93,134.132l-3.6,3.673c-.008,0-9.742,18.238-9.742,18.238v-7.154h1.849a1.556,1.556,0,0,0,1.548-1.564v-2.587a1.556,1.556,0,0,0-1.548-1.564h-1.849V131.318h1.174a1.556,1.556,0,0,0,1.548-1.564v-2.587a1.556,1.556,0,0,0-1.548-1.563h-1.174V78.284l1.679-18.206a2.213,2.213,0,0,0-1.679-2.36V52.034a2.205,2.205,0,0,0-2.194-2.216h-6.413a3.977,3.977,0,0,0-3.654-2.523l-86.459.449v-.035h-1.773a3.932,3.932,0,0,0-3.912,3.952V188.805a3.949,3.949,0,0,0,2.487,3.677v.173h.555a3.878,3.878,0,0,0,.87.1h1.773v-.022l15.389-.08h1.517l62.763,5.908.635.345.145-.272,2.626.247a4.516,4.516,0,0,0,4.9-4.107l.2-2.121h4.852a3.388,3.388,0,0,0,3.371-3.405V187.7a3.164,3.164,0,0,0,2.326-3.06V164.394l13.2-24.737,1.008-5.073.334-1.679Zm-1.022,5.058-.156-.085.157.084Z",
    transform: "translate(-197.625 -47.295)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4893",
    "data-name": "Path 4893",
    d: "M139.376,133.055a7.068,7.068,0,0,1-6.477-.568l-2.221,1.4a7.239,7.239,0,0,1-2.334,6.129Z",
    transform: "translate(-128.31 -103.62)",
    fill: "#374d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4894",
    "data-name": "Path 4894",
    d: "M158.467,165.184,141.647,138l-2.353-3.8-11.05,6.976.964,1.559-.016.01L147.4,172.17a2.622,2.622,0,0,0,3.627.832l6.59-4.16a2.68,2.68,0,0,0,.849-3.658",
    transform: "translate(-128.244 -104.746)",
    fill: "#374d78"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4874-2",
    "data-name": "Path 4874",
    d: "M336.048,180.294H243.637V42.3H337a2.2,2.2,0,0,1,2.2,2.2V177.144a3.15,3.15,0,0,1-3.15,3.15",
    transform: "translate(-200.5 -39.773)",
    fill: "#023d8e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4875-2",
    "data-name": "Path 4875",
    d: "M321.084,193.18h-96.21V54.465h97.391a2.2,2.2,0,0,1,2.2,2.2V189.8a3.382,3.382,0,0,1-3.382,3.382",
    transform: "translate(-188.095 -47.819)",
    fill: "#3a89f7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4876-2",
    "data-name": "Path 4876",
    d: "M308.235,190.133l-87.765-8.261L233.515,40.437l90.064,8.477a2.21,2.21,0,0,1,1.981,2.413l-12.424,134.7a4.516,4.516,0,0,1-4.9,4.107",
    transform: "translate(-185.183 -38.544)",
    fill: "#a6cbff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4877-2",
    "data-name": "Path 4877",
    d: "M321.376,179.837l-87.4.454V35.3l86.572-.449a4,4,0,0,1,3.937,3.965V176.672a3.108,3.108,0,0,1-3.111,3.166",
    transform: "translate(-194.114 -34.85)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4878-2",
    "data-name": "Path 4878",
    d: "M223.218,181.119h-1.76a3.925,3.925,0,0,1-3.925-3.925V40a3.925,3.925,0,0,1,3.925-3.925h1.76Z",
    transform: "translate(-183.241 -35.657)",
    fill: "#3a89f7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4879-2",
    "data-name": "Path 4879",
    d: "M215.438,55.947h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -47.971)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4880-2",
    "data-name": "Path 4880",
    d: "M215.438,61.82h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -51.854)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4881-2",
    "data-name": "Path 4881",
    d: "M215.438,103.876h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -79.66)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4882-2",
    "data-name": "Path 4882",
    d: "M215.438,109.749h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -83.543)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4883-2",
    "data-name": "Path 4883",
    d: "M215.438,151.805h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -111.348)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4884-2",
    "data-name": "Path 4884",
    d: "M215.438,157.678h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -115.231)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4885-2",
    "data-name": "Path 4885",
    d: "M215.438,199.734h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -143.037)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4886-2",
    "data-name": "Path 4886",
    d: "M215.438,205.608h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -146.92)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4887-2",
    "data-name": "Path 4887",
    d: "M215.438,247.664h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -174.726)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4888-2",
    "data-name": "Path 4888",
    d: "M215.438,253.537h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -178.609)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4889-2",
    "data-name": "Path 4889",
    d: "M215.438,295.593h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -206.414)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4890-2",
    "data-name": "Path 4890",
    d: "M215.438,301.466h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -210.297)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4891-2",
    "data-name": "Path 4891",
    d: "M215.438,343.522h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -238.103)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4892-2",
    "data-name": "Path 4892",
    d: "M215.438,349.395h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -241.986)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4893-2",
    "data-name": "Path 4893",
    d: "M215.438,391.451h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -269.791)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4894-2",
    "data-name": "Path 4894",
    d: "M215.438,397.324h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -273.674)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4895",
    "data-name": "Path 4895",
    d: "M215.438,439.38h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -301.48)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4896",
    "data-name": "Path 4896",
    d: "M215.438,445.253h-4.415a.552.552,0,0,1-.551-.551v-.15a.552.552,0,0,1,.551-.551h4.415a.552.552,0,0,1,.551.551v.15a.552.552,0,0,1-.551.551",
    transform: "translate(-178.574 -305.363)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4897",
    "data-name": "Path 4897",
    d: "M335.542,204.784,305.273,205v-2.369l30.268-.212Z",
    transform: "translate(-240.102 -139.113)",
    fill: "#3a89f7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4898",
    "data-name": "Path 4898",
    d: "M408.857,204.6l-6.235.044v-2.369l6.235-.044Z",
    transform: "translate(-304.465 -138.99)",
    fill: "#3a89f7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4899",
    "data-name": "Path 4899",
    d: "M319.235,219.976l-13.962.1V217.7l13.962-.1Z",
    transform: "translate(-240.102 -149.156)",
    fill: "#3a89f7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4900",
    "data-name": "Path 4900",
    d: "M377.143,219.453l-22.488.158v-2.368l22.488-.158Z",
    transform: "translate(-272.752 -148.811)",
    fill: "#3a89f7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4901",
    "data-name": "Path 4901",
    d: "M330.235,234.765l-24.727.173v-2.368l24.727-.173Z",
    transform: "translate(-240.258 -158.934)",
    fill: "#3a89f7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4902",
    "data-name": "Path 4902",
    d: "M517.287,271.671h-6.065l.563-5.714h5.5a1.556,1.556,0,0,1,1.548,1.563v2.587a1.556,1.556,0,0,1-1.548,1.564",
    transform: "translate(-377.415 -187.648)",
    fill: "#001c69"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4903",
    "data-name": "Path 4903",
    d: "M523.069,317.808h-4.123v5.714h4.123a1.556,1.556,0,0,0,1.548-1.564v-2.587a1.556,1.556,0,0,0-1.548-1.564",
    transform: "translate(-382.522 -221.929)",
    fill: "#8264a3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3517",
    "data-name": "Group 3517",
    transform: "translate(117.591 111.505)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3522",
    "data-name": "Group 3522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3521",
    "data-name": "Group 3521",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4936",
    "data-name": "Path 4936",
    d: "M484.479,363.925l-21.114,39.567,4.242.4,16.872-31.618Z",
    transform: "translate(-463.365 -363.925)",
    fill: "#374d78"
  }))))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4904",
    "data-name": "Path 4904",
    d: "M129.735,134.109l-11.05,6.976-2.353-3.8,11.05-6.976Z",
    transform: "translate(-116.331 -97.96)",
    fill: "#647fa3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4905",
    "data-name": "Path 4905",
    d: "M127.463,129.169a7.067,7.067,0,0,1-6.477-.568l-2.221,1.4a7.24,7.24,0,0,1-2.334,6.13Z",
    transform: "translate(-116.397 -96.834)",
    fill: "#98b3c1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4906",
    "data-name": "Path 4906",
    d: "M137.341,171.326a2.622,2.622,0,0,0,3.627.832l6.59-4.16a2.681,2.681,0,0,0,.849-3.658L130.2,134.906l-11.066,6.986Z",
    transform: "translate(-118.183 -101.002)",
    fill: "#008bf4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4907",
    "data-name": "Path 4907",
    d: "M123.147,125.843l-1.922,1.213-1.3-2.1,2.271-.648Z",
    transform: "translate(-118.706 -93.993)",
    fill: "#cfd600"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4917",
    "data-name": "Path 4917",
    d: "M379.24,289.26a.773.773,0,0,1-1.1,0l-.509-.514a.792.792,0,0,1,0-1.109l1.729-1.746a2.76,2.76,0,0,0-2.955.638,2.827,2.827,0,0,0,0,3.97,2.759,2.759,0,0,0,3.93,0,2.828,2.828,0,0,0,.631-2.985Z",
    transform: "translate(-287.744 -200.705)",
    fill: "#3a89f7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4918",
    "data-name": "Path 4918",
    d: "M340.884,326.384a2.759,2.759,0,0,0-3.93,0,2.828,2.828,0,0,0-.631,2.986l1.729-1.746a.773.773,0,0,1,1.1,0l.509.514a.792.792,0,0,1,0,1.109l-1.729,1.746a2.759,2.759,0,0,0,2.955-.638,2.828,2.828,0,0,0,0-3.97",
    transform: "translate(-261.659 -227.056)",
    fill: "#3a89f7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4919",
    "data-name": "Path 4919",
    d: "M345.95,318.684a.394.394,0,0,0,0,.552l1.018,1.028a.385.385,0,0,0,.547,0l4.432-4.477-1.608-1.537Z",
    transform: "translate(-268.07 -219.577)",
    fill: "#3a89f7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4920",
    "data-name": "Path 4920",
    d: "M371.841,296.42l-1.018-1.028a.385.385,0,0,0-.547,0l-3.738,3.776,1.611,1.534,3.692-3.73a.394.394,0,0,0,0-.552",
    transform: "translate(-281.757 -207.033)",
    fill: "#3a89f7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4921",
    "data-name": "Path 4921",
    d: "M372.072,319.573a1.283,1.283,0,0,1-1.823,0L362.3,311.54a1.315,1.315,0,0,1,0-1.841,1.284,1.284,0,0,1,1.823,0l7.951,8.032a1.315,1.315,0,0,1,0,1.841",
    transform: "translate(-278.705 -216.317)",
    fill: "#3a89f7"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4922",
    "data-name": "Path 4922",
    d: "M352.255,299.553a.492.492,0,0,1-.7,0l-6.243-6.306a.505.505,0,0,1,0-.706.492.492,0,0,1,.7,0l6.243,6.306a.5.5,0,0,1,0,.706",
    transform: "translate(-267.629 -205.127)",
    fill: "#3a89f7"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4923",
    "data-name": "Path 4923",
    d: "M341.875,290.338l-1.395-1.777a.177.177,0,0,1,.014-.233l.647-.654a.173.173,0,0,1,.231-.014l1.759,1.409a.177.177,0,0,1,.015.262l-1.012,1.022a.172.172,0,0,1-.259-.015",
    transform: "translate(-264.504 -201.971)",
    fill: "#3a89f7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4924",
    "data-name": "Path 4924",
    d: "M365.553,306.759l-.5.478a1.526,1.526,0,0,1,1.393.368Z",
    transform: "translate(-280.772 -214.624)",
    fill: "#3a89f7"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4925",
    "data-name": "Path 4925",
    d: "M359.113,313.295l.447-.5a1.5,1.5,0,0,0,.437,1.347Z",
    transform: "translate(-276.848 -218.617)",
    fill: "#3a89f7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4926",
    "data-name": "Path 4926",
    d: "M464.918,364.284l-1.706-.929,31.617-59.25,1.706.929Z",
    transform: "translate(-345.673 -212.869)",
    fill: "#000f96"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4927",
    "data-name": "Path 4927",
    d: "M469.136,366.548l-.876-.477,31.618-59.251.876.477Z",
    transform: "translate(-349.011 -214.664)",
    fill: "#66a3ff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4928",
    "data-name": "Path 4928",
    d: "M461.494,362.476l-.876-.477,31.618-59.251.876.477Z",
    transform: "translate(-343.958 -211.972)",
    fill: "#66a3ff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4929",
    "data-name": "Path 4929",
    d: "M565.773,288.3l-1.2,1.226.867.453Z",
    transform: "translate(-412.688 -202.421)",
    fill: "#21213a"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4930",
    "data-name": "Path 4930",
    d: "M557.537,291.92l-3.605,3.68,3.465,1.846,1.008-5.072Z",
    transform: "translate(-405.653 -204.813)",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4938",
    "data-name": "Path 4938",
    d: "M-38.828-7.149a2.567,2.567,0,0,0-2.044.862,3.477,3.477,0,0,0-.749,2.361A3.547,3.547,0,0,0-40.9-1.544a2.568,2.568,0,0,0,2.06.841A7.033,7.033,0,0,0-36.964-1v.8a5.772,5.772,0,0,1-2.014.306A3.407,3.407,0,0,1-41.656-.945,4.335,4.335,0,0,1-42.6-3.937a4.722,4.722,0,0,1,.454-2.127,3.258,3.258,0,0,1,1.311-1.407,3.967,3.967,0,0,1,2.017-.494,4.866,4.866,0,0,1,2.159.451l-.387.784A4.162,4.162,0,0,0-38.828-7.149Zm10.393,3.212a4.323,4.323,0,0,1-.953,2.965A3.352,3.352,0,0,1-32.039.107,3.394,3.394,0,0,1-34.716-.953a4.358,4.358,0,0,1-.943-2.994,4.3,4.3,0,0,1,.945-2.973,3.418,3.418,0,0,1,2.686-1.055A3.345,3.345,0,0,1-29.385-6.9,4.319,4.319,0,0,1-28.435-3.937Zm-6.257,0a3.727,3.727,0,0,0,.679,2.42,2.411,2.411,0,0,0,1.974.824,2.388,2.388,0,0,0,1.971-.822A3.779,3.779,0,0,0-29.4-3.937a3.749,3.749,0,0,0-.663-2.4,2.377,2.377,0,0,0-1.963-.819,2.423,2.423,0,0,0-1.985.824A3.689,3.689,0,0,0-34.692-3.937ZM-20.55,0h-1.042l-4.292-6.59h-.043q.086,1.16.086,2.127V0h-.843V-7.853h1.031l4.281,6.563h.043q-.011-.145-.048-.932T-21.4-3.346V-7.853h.854Zm6.59-2.089a1.926,1.926,0,0,1-.752,1.617,3.26,3.26,0,0,1-2.041.58A5.112,5.112,0,0,1-18.9-.252v-.881a5.656,5.656,0,0,0,1.053.322,5.539,5.539,0,0,0,1.128.118,2.276,2.276,0,0,0,1.375-.346A1.137,1.137,0,0,0-14.883-2a1.238,1.238,0,0,0-.164-.669,1.522,1.522,0,0,0-.548-.481,7.664,7.664,0,0,0-1.168-.5,3.729,3.729,0,0,1-1.566-.929,2.051,2.051,0,0,1-.47-1.4,1.743,1.743,0,0,1,.682-1.445,2.835,2.835,0,0,1,1.8-.537,5.319,5.319,0,0,1,2.154.43l-.285.795a4.867,4.867,0,0,0-1.891-.408,1.83,1.83,0,0,0-1.133.312,1.027,1.027,0,0,0-.408.865,1.325,1.325,0,0,0,.15.669,1.416,1.416,0,0,0,.508.478,6.306,6.306,0,0,0,1.093.481,4.327,4.327,0,0,1,1.7.945A1.859,1.859,0,0,1-13.959-2.089ZM-9.937,0h-.913V-7.042h-2.487v-.811H-7.45v.811H-9.937Zm4.582-3.266V0h-.913V-7.853h2.154A3.389,3.389,0,0,1-1.979-7.3a2.006,2.006,0,0,1,.69,1.665A2.086,2.086,0,0,1-2.868-3.529L-.736,0h-1.08l-1.9-3.266Zm0-.784H-4.1a2.161,2.161,0,0,0,1.418-.384,1.429,1.429,0,0,0,.451-1.152,1.311,1.311,0,0,0-.459-1.123,2.488,2.488,0,0,0-1.474-.344H-5.355Zm11.816-3.8v5.081A2.768,2.768,0,0,1,5.65-.661,3.111,3.111,0,0,1,3.421.107,2.973,2.973,0,0,1,1.227-.666,2.869,2.869,0,0,1,.451-2.793v-5.06h.913v5.124A2.018,2.018,0,0,0,1.9-1.219,2.167,2.167,0,0,0,3.48-.693a2.09,2.09,0,0,0,1.531-.529,2.035,2.035,0,0,0,.537-1.517V-7.853Zm5.441.7a2.567,2.567,0,0,0-2.044.862,3.477,3.477,0,0,0-.749,2.361,3.547,3.547,0,0,0,.722,2.382,2.568,2.568,0,0,0,2.06.841A7.033,7.033,0,0,0,13.766-1v.8a5.773,5.773,0,0,1-2.014.306A3.407,3.407,0,0,1,9.074-.945a4.335,4.335,0,0,1-.943-2.992,4.722,4.722,0,0,1,.454-2.127A3.258,3.258,0,0,1,9.9-7.471a3.967,3.967,0,0,1,2.017-.494,4.866,4.866,0,0,1,2.159.451l-.387.784A4.162,4.162,0,0,0,11.9-7.149ZM17.9,0h-.913V-7.042H14.5v-.811h5.887v.811H17.9Zm3.668,0V-7.853h.913V0Zm9.883-3.937a4.323,4.323,0,0,1-.953,2.965A3.352,3.352,0,0,1,27.844.107,3.394,3.394,0,0,1,25.166-.953a4.358,4.358,0,0,1-.943-2.994,4.3,4.3,0,0,1,.945-2.973,3.418,3.418,0,0,1,2.686-1.055A3.345,3.345,0,0,1,30.5-6.9,4.319,4.319,0,0,1,31.448-3.937Zm-6.257,0a3.727,3.727,0,0,0,.679,2.42,2.411,2.411,0,0,0,1.974.824,2.388,2.388,0,0,0,1.971-.822,3.779,3.779,0,0,0,.666-2.422,3.749,3.749,0,0,0-.663-2.4,2.377,2.377,0,0,0-1.963-.819,2.423,2.423,0,0,0-1.985.824A3.689,3.689,0,0,0,25.19-3.937ZM39.333,0H38.291L34-6.59h-.043q.086,1.16.086,2.127V0H33.2V-7.853H34.23l4.281,6.563h.043q-.011-.145-.048-.932t-.027-1.125V-7.853h.854Z",
    transform: "translate(86.956 36.545)",
    fill: "#3a89f7"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4937",
    "data-name": "Path 4937",
    d: "M-33.051,0l-3.094-10.081h-.079q.167,3.076.167,4.1V0h-2.435V-12.85h3.709l3.041,9.826h.053l3.226-9.826h3.709V0h-2.54V-6.082q0-.431.013-.993t.119-2.988h-.079L-30.555,0Zm19.4,0-.932-3.059H-19.27L-20.2,0h-2.936L-18.6-12.9h3.331L-10.718,0Zm-1.582-5.344q-1.292-4.157-1.455-4.7t-.233-.861q-.29,1.125-1.661,5.563ZM2.3,0H-1.165l-5.59-9.721h-.079q.167,2.575.167,3.674V0H-9.1V-12.85h3.437L-.083-3.226h.062q-.132-2.5-.132-3.542V-12.85H2.3ZM15.992-12.85v8.314a4.793,4.793,0,0,1-.637,2.5A4.147,4.147,0,0,1,13.513-.4a6.585,6.585,0,0,1-2.848.571,5.453,5.453,0,0,1-3.85-1.27A4.505,4.505,0,0,1,5.445-4.57V-12.85H8.161v7.866a3.3,3.3,0,0,0,.6,2.18,2.485,2.485,0,0,0,1.978.694,2.429,2.429,0,0,0,1.938-.7A3.312,3.312,0,0,0,13.276-5V-12.85ZM27,0l-.932-3.059H21.388L20.457,0H17.521l4.535-12.9h3.331L29.94,0ZM25.422-5.344q-1.292-4.157-1.455-4.7t-.233-.861q-.29,1.125-1.661,5.563ZM31.557,0V-12.85h2.725v10.6h5.212V0Z",
    transform: "translate(85.956 54.545)",
    fill: "#3a89f7"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "new_eng_logo_00000024696991566798266240000007640574015663551409_",
    transform: "translate(45.957 117.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4548_00000018235421647326842730000012798603759926974383_",
    d: "M58.5,70.147H57.1L56.319,67.1c-.03-.12-.09-.329-.15-.688a6.674,6.674,0,0,1-.12-.688c-.03.15-.06.359-.12.688s-.12.539-.15.688L55,70.147H53.6l-1.5-5.8h1.227l.748,3.172q.18.9.269,1.526c.03-.15.06-.389.12-.688.06-.329.12-.569.15-.748l.838-3.262h1.167l.838,3.262c.03.15.09.359.15.658s.09.568.12.778c.03-.209.06-.479.12-.778s.12-.569.15-.748l.748-3.172h1.227Zm3.441,0H60.717v-5.8h3.321v1.017H61.944v1.5h1.975v1.017H61.944Zm4.488-3.082h.419a1.2,1.2,0,0,0,.838-.239.749.749,0,0,0,.269-.658.7.7,0,0,0-.239-.628,1.1,1.1,0,0,0-.748-.209h-.539Zm2.783-.9a1.76,1.76,0,0,1-.6,1.436,2.588,2.588,0,0,1-1.676.509h-.509v2.065H65.2V64.342H67.06a2.6,2.6,0,0,1,1.616.449,1.783,1.783,0,0,1,.539,1.376Zm11.549,3.98H77.412v-5.8h3.351v1.017H78.639v1.287h1.975v1.017H78.639v1.5h2.124Zm6.373,0H85.581l-2.513-4.4h-.03c.06.778.09,1.317.09,1.676v2.723H81.99v-5.8h1.556l2.513,4.339h.03c-.03-.748-.06-1.287-.06-1.616V64.312h1.107Zm3.68-3.262h2.3v3.022a5.97,5.97,0,0,1-1.047.269,5.639,5.639,0,0,1-1.017.06,2.512,2.512,0,0,1-2-.778,3.268,3.268,0,0,1-.688-2.214,2.815,2.815,0,0,1,.808-2.184,3.041,3.041,0,0,1,2.244-.778,4.4,4.4,0,0,1,1.735.359l-.419.987a2.956,2.956,0,0,0-1.316-.329,1.635,1.635,0,0,0-1.287.539,2.09,2.09,0,0,0-.479,1.436,2.228,2.228,0,0,0,.389,1.436,1.365,1.365,0,0,0,1.137.509,3.259,3.259,0,0,0,.778-.09V67.9H90.846Zm3.68,3.262v-5.8h1.227v5.8Zm7.839,0H100.78l-2.513-4.4h-.03c.06.778.09,1.317.09,1.676v2.723H97.219v-5.8h1.556l2.513,4.339h.03c-.03-.748-.06-1.287-.06-1.616V64.312h1.107Zm4.817,0H103.8v-5.8h3.351v1.017h-2.124v1.287H107v1.017h-1.975v1.5h2.124Zm4.548,0H108.35v-5.8H111.7v1.017h-2.124v1.287h1.975v1.017h-1.975v1.5H111.7Zm2.453-3.232h.389a1.744,1.744,0,0,0,.868-.18.8.8,0,0,0,0-1.2,1.473,1.473,0,0,0-.868-.18h-.359Zm0,1.017v2.244h-1.227V64.342h1.705a3.133,3.133,0,0,1,1.765.419,1.59,1.59,0,0,1,.568,1.317,1.516,1.516,0,0,1-.269.9,1.858,1.858,0,0,1-.808.628c.868,1.317,1.436,2.154,1.705,2.543h-1.376L114.842,67.9Zm4.129,2.214v-5.8h1.227v5.8Zm7.869,0H124.6l-2.513-4.4h-.03c.06.778.09,1.317.09,1.676v2.723h-1.107v-5.8h1.556l2.513,4.339h.03c-.03-.748-.06-1.287-.06-1.616V64.312h1.107Zm3.65-3.262h2.3v3.022a5.971,5.971,0,0,1-1.047.269,5.64,5.64,0,0,1-1.017.06,2.512,2.512,0,0,1-2-.778,3.268,3.268,0,0,1-.688-2.214,2.815,2.815,0,0,1,.808-2.184,3.041,3.041,0,0,1,2.244-.778,4.4,4.4,0,0,1,1.735.359l-.419.987A2.955,2.955,0,0,0,130.4,65.3a1.635,1.635,0,0,0-1.287.539,2.089,2.089,0,0,0-.479,1.436,2.227,2.227,0,0,0,.389,1.436,1.365,1.365,0,0,0,1.137.509,3.26,3.26,0,0,0,.778-.09V67.9h-1.107Z",
    transform: "translate(-52.1 -64.275)",
    fill: "#3a89f7"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3519",
    "data-name": "Group 3519",
    transform: "translate(66.718 117.125)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2999",
    "data-name": "Rectangle 2999",
    width: 0.449,
    height: 5.805,
    transform: "translate(-0.001 0)",
    fill: "#3a89f7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionManual);
export default __webpack_public_path__ + "static/media/construction_manual.bce00bcf9d923343af866959cb46e461.svg";
export { ForwardRef as ReactComponent };